import React from "react";
import styled from "styled-components";
import Icon from "../components/Icon";
import { TextTitle } from "../components/Texts";
import colors from "../styles/colors";

const Monitor = () => {
  return (
    <StyledContainer>
      <div className="circle">
        <Icon name="icon-ok" size="48px" color={colors.positive} />
      </div>
      <TextTitle color={colors.white} size="48px">
        OK
      </TextTitle>
    </StyledContainer>
  );
};

export default Monitor;

const StyledContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${colors.positive};

  .circle {
    background-color: white;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
